/**
 * EventEmitter class for handling events
 */
export class EventEmitter {
    private eventHandlers: { [key: string]: Function[] };

    constructor() {
        this.eventHandlers = {};
    }

    clearEventListeners(): void {
        this.eventHandlers = {};
    }

    emit(event: string, ...args: any[]): void {
        if (!this.eventHandlers[event]) {
            return;
        }

        for (let i = 0; i < this.eventHandlers[event].length; i++) {
            this.eventHandlers[event][i](...args);
        }
    }

    addEventListener(event: string, handler: Function): this {
        if (!this.eventHandlers[event]) {
            this.eventHandlers[event] = [];
        }

        this.eventHandlers[event].push(handler);
        return this;
    }

    on(event: string, handler: Function): this {
        return this.addEventListener(event, handler);
    }

    removeEventListener(event: string, handler: Function): boolean {
        if (!this.eventHandlers[event]) {
            return false;
        }

        const handlerIdx = this.eventHandlers[event].indexOf(handler);
        if (handlerIdx !== -1) {
            this.eventHandlers[event].splice(handlerIdx, 1);
            return true;
        }

        return false;
    }

    once(event: string, handler: Function): this {
        const onceHandler = (...args: any[]) => {
            this.removeEventListener(event, onceHandler);
            handler(...args);
        };

        this.addEventListener(event, onceHandler);
        return this;
    }
}
